var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Injectable } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { ApiService } from '../../service/api.service';
import { ContentBaseService } from '../base/contentbase.service';
var ButtonService = /** @class */ (function (_super) {
    __extends(ButtonService, _super);
    function ButtonService(logger, api) {
        var _this = _super.call(this, logger, api) || this;
        _this.logger = logger;
        _this.api = api;
        return _this;
    }
    ButtonService.decorators = [
        { type: Injectable }
    ];
    /** @nocollapse */
    ButtonService.ctorParameters = function () { return [
        { type: NGXLogger },
        { type: ApiService }
    ]; };
    return ButtonService;
}(ContentBaseService));
export { ButtonService };
//# sourceMappingURL=button.service.js.map